import cloudImage from 'assets/cloud.svg';
import styled from 'styled-components';

import { breakpoint } from 'app/theme/theme';
import { automatedQuoteGeneration } from 'app/translations/dictionary/automatedQuoteGeneration';
import { DialogWithImage } from 'pkg/components/DialogWithImage';

import { UpdaterEmailForm } from './UpdaterEmailForm';

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.8rem;
  text-align: center;
  margin: 0.6rem 0;
  ${breakpoint.up.sm`
    font-size: 2.2rem;
    text-align: left;
    line-height: 3.5rem; 
  `}
  ${breakpoint.up.md`
    font-size: 3.5rem;    
    line-height: 4.7rem;
  `}
`;

const InformationText = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.6rem;
  text-align: center;
  ${breakpoint.up.sm`
    text-align: left;
  `}
  ${breakpoint.up.md`
    font-size: 2.2rem;
    line-height: 3.5rem;    
    margin: 0.8rem 0;
  `}
`;

const DialogContent = styled.div`
  max-width: 40rem;
  margin-top: 1.8rem;
  ${breakpoint.up.sm`
    max-width: 100%;
    margin: 0 6.5rem 0 1.5rem;
  `}
`;

const Image = styled.img`
  width: 12.3rem;
  height: 10.9rem;
  ${breakpoint.up.sm`
    width: 21.2rem;
    height: 18.8rem;
  `}
  ${breakpoint.up.md`
    width: 30.2rem;
    height: 26.8rem;
  `}
`;

export const AutomatedQuoteGeneration = (): JSX.Element => (
  <DialogWithImage
    onClose={() => window.location.replace('/')}
    image={<Image src={cloudImage} alt={automatedQuoteGeneration.altImg} />}
  >
    <DialogContent>
      <Title>{automatedQuoteGeneration.dialogTitle}</Title>
      <InformationText>{automatedQuoteGeneration.information}</InformationText>
      <UpdaterEmailForm />
    </DialogContent>
  </DialogWithImage>
);
